import { Component } from 'react'
import classNames from 'classnames'
import Select from 'react-select'
import 'react-select/dist/react-select.min.css'

import styles from './YSelect.css'
import { PickerArrow } from './InputPicker'

class YSelect extends Component {
  render () {
    const { className, size = '', instanceId, name, ...props } = this.props
    const classes = classNames(
      styles.YSelect,
      className,
      {
        [styles.small]: size === 'small'
      }
    )
    return (
      <Select
        className={classes}
        autosize={false}
        instanceId={instanceId || name}
        searchable={false}
        clearable={false}
        backspaceRemoves={false}
        noResultsText='查無可用選項'
        placeholder='請選擇'
        arrowRenderer={({ onMouseDown, isOpen }) => {
          return <PickerArrow isOpen={isOpen} />
        }}
        {...props}
      />
    )
  }
}

export default YSelect
